module.exports = __webpack_public_path__ + "static/media/landing_insights_2.a970f872.png";